/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_OffInputs */



/**
* | output |
* | --- |
* | "Microphone is off" |
*
* @param {Practice_Session_Mic_OffInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_off = /** @type {((inputs?: Practice_Session_Mic_OffInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_OffInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microfoon staat uit")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Micro coupé")
	return /** @type {LocalizedString} */ ("Microphone is off")
});